import * as React from 'react';
import Dialog from '../../../../../../../BaseComponents/Dialog/EDDialog';
import ModifyUrval from '../ModifyUrval';
import {
  IUIUrval,
  TEDInputUrvalType,
  TEDUrvalVisibility,
} from '../../../../../../../Types/UrvalTypes';

interface IProps {
  title: string;
  modifyUrval: (
    urval: IUIUrval,
    urvalInput: TEDInputUrvalType
  ) => Promise<void>;
  urval: IUIUrval;
  collectionName: string;
  userId?: string;
  rutinId: number;
  kodplanId: string;
  open: boolean;
  onClose: () => void;
  availableVisibilityOptions: TEDUrvalVisibility[];
  usageCode?: string;
}

class ModifyUrvalDialog extends React.Component<IProps> {
  okClick?: () => void;
  setOKClick = (okClick: () => void) => {
    this.okClick = okClick;
  };

  handleOKClick = () => {
    if (this.okClick) {
      this.okClick();
    }
  };

  render() {
    const { savedUrvalProps } = this.props.urval;

    return (
      <Dialog
        data-test={`dialog:${this.props.title}`}
        open={this.props.open}
        title={this.props.title}
        onClose={this.props.onClose}
        footerActions={[
          {
            onClick: this.props.onClose,
            label: 'Avbryt',
          },
          {
            onClick: this.handleOKClick,
            label: 'Spara',
          },
        ]}
      >
        {savedUrvalProps != null && (
          <ModifyUrval
            setOKClick={this.setOKClick}
            modifyUrval={this.props.modifyUrval}
            urval={this.props.urval}
            kodplanID={this.props.kodplanId}
            initialValues={{
              name: savedUrvalProps.namn,
              description:
                savedUrvalProps.beskrivning != null
                  ? savedUrvalProps.beskrivning
                  : null,
              visibility: savedUrvalProps.synlighet,
            }}
            collectionName={this.props.collectionName}
            onSuccess={this.props.onClose}
            userId={this.props.userId}
            rutinId={this.props.rutinId}
            usageCode={this.props.usageCode}
            availableVisibilityOptions={this.props.availableVisibilityOptions}
          />
        )}
      </Dialog>
    );
  }
}

export default ModifyUrvalDialog;
